import React, { useRef } from 'react';
import { useDrag, useDrop } from 'react-dnd';
import { Icon } from '../../../icon';
import { useElementHasScroll } from '../../../../hooks/useElementHasScroll';
import { StyledRow, StyledToggle, StyledLabel, StyledTooltip } from './styled';
const ItemTypes = {
    settingsRow: 'SettingsRow'
};
export const SettingsRow = ({ label, checked, onChange, index, onOrderChange, id, disabled, tooltipStyle }) => {
    const ref = useRef(null);
    const [, drop] = useDrop({
        accept: ItemTypes.settingsRow,
        drop(item, monitor) {
            if (!ref.current) {
                return;
            }
            const dragIndex = item.index;
            const hoverIndex = index;
            if (dragIndex === hoverIndex) {
                return;
            }
            onOrderChange(dragIndex, hoverIndex);
        }
    });
    const [{ isDragging }, drag] = useDrag({
        type: ItemTypes.settingsRow,
        item: { id, index },
        collect: (monitor) => ({
            isDragging: monitor.isDragging()
        }),
        canDrag: checked
    });
    const labelRef = useRef(null);
    const hasScroll = useElementHasScroll(labelRef);
    drag(drop(ref));
    return (React.createElement(StyledRow, { ref: ref, style: { opacity: isDragging ? 0 : 1 } },
        React.createElement(Icon, { name: "drag_indicator", style: { opacity: checked ? 1 : 0 } }),
        React.createElement(StyledToggle, { label: React.createElement(StyledTooltip, { disabled: !hasScroll, content: label, "$external": tooltipStyle },
                React.createElement("div", null,
                    React.createElement(StyledLabel, { ref: labelRef }, label))), checked: checked, onChange: onChange, disabled: disabled })));
};
